// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"121":"e24a3f98","183":"cd3d7915","280":"2635b6f0","453":"99dcf01f"}[chunkId] + ".chunk.js";
};